/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */
/* eslint-disable func-names */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/self-closing-comp */
/* eslint-disable prefer-const */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/label-has-associated-control */
import "react-big-calendar/lib/sass/styles.scss";
import "react-datepicker/dist/react-datepicker.css";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { faCalculator, faCheck, faClock, faHeadSideVirus } from "@fortawesome/free-solid-svg-icons";
import { Tab, Tabs } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { Helmet } from "react-helmet";
import { useLocation, withRouter } from "react-router";
import { BlurSpinner } from "../../../components/BlurSpinner";
import Breadcrumb from "../../../components/common/breadcrumb";
import DateRangeComponent from "../../../components/DateRange";
import KpiCard from "../../../components/kpiCard";
import { StyledSelect } from "../../../components/StyledSelect";
import ModalCalendarEvent from "../ModalCalendarEvent";
import { fetchNovedades } from "../../../services/novedadesServices";
import useFetcher from "../../../hooks/useFetcher";
import { novedadUtil, statusNovedad } from "../../../utils/novedadUtil";
import TaskEdit from "../../NovedadDetail/TaskEdit";
import modulos from "../../../mocks/modulos";
// import ACTIVITIES from "../../../activities.json";
import { fetchTaskCategories } from "../../../services/taskServices";
import { useAuth } from "../../../context/AuthContext";
import { taskUtil } from "../../../utils/taskUtil";
import SubclientesModal from "../ModalCalendarEvent/subclientesModal";
import TaskListTableCentralizer from "../../../components/TaskList/taskListTableCentralizer";

moment.locale("es", {
  months: "Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre".split("_"),
  monthsShort: "Enero._Feb._Mar_Abr._May_Jun_Jul._Ago_Sept._Oct._Nov._Dec.".split("_"),
  weekdays: "Domingo_Lunes_Martes_Miercoles_Jueves_Viernes_Sabado".split("_"),
  weekdaysShort: "Dom._Lun._Mar._Mier._Jue._Vier._Sab.".split("_"),
  weekdaysMin: "Do_Lu_Ma_Mi_Ju_Vi_Sa".split("_"),
});

const actualYearStr = moment().format("YYYY");
const firstDayLastYear = `1/1/${actualYearStr - 1}`;
const monthStrList = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

const locale = {
  localize: {
    month: (n) => monthStrList[n],
  },
  formatLong: {
    date: () => "dd/mm/yyyy",
  },
};

const optionsMonth = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const monthQuery = query.get("month");
  const yearQuery = query.get("year");
  const monthStrList = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
  const yearList = ["2022", "2023", "2024", "2025", "2026", "2027", "2028", "2029", "2030"];
  const monthOptions = [];
  const yearOptions = [];
  const actualMonth = Number(monthQuery) || Number(moment().format("MM"));
  const actualYear = Number(yearQuery) || Number(moment().format("YYYY"));

  for (let index = 0; index < monthStrList.length; index += 1) {
    const element = {
      label: monthStrList[index],
      value: index + 1,
    };
    monthOptions.push(element);
  }
  for (let index = 0; index < yearList.length; index += 1) {
    const element = {
      label: yearList[index],
      value: Number(yearList[index]),
    };
    yearOptions.push(element);
  }

  const actualMonthOption = monthOptions.find((m) => m.value === actualMonth);
  const actualYearOption = yearOptions.find((m) => m.value === actualYear);
  return [actualMonth, actualMonthOption, actualYear, actualYearOption];
};

const countKpis = (novedades = []) => {
  let pendientes = 0;
  let gestion = 0;
  let resuelto = 0;
  let tareasCentralizadas = [];

  novedades.forEach((nov) => {
    nov.tareas.forEach((tarea) => {
      tarea.razonSocial = nov.cliente.razonSocial;
    });
    const find = nov.tareas.find((tarea) => {
      return tarea.centralizer;
    });
    if (find) {
      tareasCentralizadas.push(find);
    }
  });

  let finishFilter = tareasCentralizadas.reduce((acc, el) => {
    const find = acc.find((t) => {
      return t.razonSocial === el.razonSocial && t.type === el.type;
    });
    if (!find) {
      acc.push(el);
    }

    return acc;
  }, []);

  for (const task of finishFilter) {
    pendientes += task.completeDate === null ? 1 : 0;
    resuelto += task.completeDate === null ? 0 : 1;
  }
  const total = pendientes + gestion + resuelto;

  return { total, pendientes, gestion, resuelto };
};

const optionsClient = (novedades = []) => {
  const clientesSet = new Set();
  const clientesArr = [];
  novedades.forEach((nov) => {
    const cli = nov.cliente;
    const has = clientesSet.has(cli.razonSocial);
    if (!has) {
      clientesSet.add(cli.razonSocial);
      clientesArr.push({ label: cli.razonSocial, value: cli.razonSocial });
    }
  });
  return clientesArr;
};

const tasksForCalendar = (novedades = [], categoriesTask) => {
  const types = categoriesTask.type;
  const tareas = novedades
    .reduce((allTasks, novedad) => {
      const tasks = [...novedad.tareas].map((tarea) => {
        const clienteStr = novedad.cliente.razonSocial ? `${novedad.cliente.numeroDeLegajo.replace(".0000", "")} - ${novedad.cliente.razonSocial}` : "";
        const typeTaskStr = types ? types.find((type) => type.id === tarea.type).text : "";
        return { ...tarea, title: `${clienteStr} ${typeTaskStr}` };
      });
      return [...allTasks, ...tasks];
    }, [])
    .map((tarea) => {
      const taskCalendar = {
        ...tarea,
        start: moment(tarea.dueDate).toDate(),
        end: moment(tarea.dueDate).add(1, "days").toDate(),
      };
      return taskCalendar;
    });
  return tareas;
};

const novedadesWithresponsable = (novedades = []) => {
  const novedadesList = novedades.map((novedad) => {
    const { tareas } = novedad;
    const orderedTasks = tareas.sort((a, b) => moment(a.dueDate) - moment(b.dueDate));
    const nextToCompleteIndex = orderedTasks.findIndex((task) => task.completeDate === null);
    if (tareas.length > 0 && nextToCompleteIndex !== -1) {
      const responsableObj = orderedTasks[nextToCompleteIndex].responsable;
      return { ...novedad, responsable: responsableObj };
    }
    return { ...novedad, responsable: { nombreApellido: novedad.responsable.nombreApellido } };
  });
  return novedadesList;
};

const cacheFetchNovedades = (location) => {
  if (location.state && location.state.novedades && Array.isArray(location.state.novedades.rows)) {
    return async (params) => {
      if (params.forceRefresh) {
        // eslint-disable-next-line no-param-reassign
        delete params.forceRefresh;
        return fetchNovedades(params);
      }
      return { result: location.state.novedades };
    };
  }
  return fetchNovedades;
};

const CalendarsCentralizer = ({ history, location }) => {
  // eslint-disable-next-line max-len
  const { currentUser } = useAuth();
  const [actualMonth, actualMonthOption, actualYear, actualYearOption] = optionsMonth();
  const [monthSelected, setMonthSelected] = useState(actualMonthOption.value - 1);
  const [yearSelected, setYearSelected] = useState(actualYearOption.value);
  const newDate = new Date();
  newDate.setFullYear(actualYear);
  newDate.setMonth(actualMonth - 1);
  const [selectedDate, setSelectedDate] = useState(newDate);
  const [categoriesTask] = useFetcher(fetchTaskCategories);
  // const novedadesFilter = [{ month: monthSelected + 1, year: yearSelected }];
  const novedadesFilter = [{ month: actualMonth, year: actualYear }];
  const [novedades, isLoadingNovedades, errNovedades, , refreshNovedades] = useFetcher(cacheFetchNovedades(location), novedadesFilter);
  const novedadesData = novedades && novedades.rows;
  const clientesOpt = optionsClient(novedadesData);
  const [clienteSelected, setClienteSelected] = useState(location.state && location.state.clienteSelected ? location.state.clienteSelected : undefined);
  const [findQuery, setFindQuery] = useState(location.state && location.state.findQuery ? location.state.findQuery : "");
  const [filterStatus, setFilterStatus] = useState(location.state && location.state.filterStatus ? location.state.filterStatus : undefined);
  const [eventSelected, setEventSelected] = useState();
  const [isOpenModal, setIsOpenModal] = useState();
  const [dateRange, setDateRange] = useState(location.state && location.state.dateRange ? location.state.dateRange : {});
  const [novedadesFiltered, setNovedadesFiltered] = useState(novedadesData || []);
  const [kpiResults, setKpiResults] = useState(countKpis(novedadesFiltered));
  const { total: kpiTotal, pendientes: kpiPendiente, gestion: kpiGestion, resuelto: kpiResuelto } = kpiResults;
  const isAdmin = currentUser.haveAdminAccess(modulos.CALENDAR);
  const [tareasCalendar, setTareasCalendar] = useState([]);
  const [tareas, setTareas] = useState([]);
  const [tareasCalc, setTareasCalc] = useState([]);
  const [tareaUpdated, setTareaUpdated] = useState(false);
  const [tareasCentralizadas, setTareasCentralizadas] = useState([]);
  const [currentPage, setCurrentPage] = useState(location.state && location.state.currentPage);
  const minRangeDate = moment({ month: monthSelected, year: actualYearStr }).startOf("month");
  const maxRangeDate = moment({ month: monthSelected, year: actualYearStr }).endOf("month");
  const [calendarDate, setCalendarDate] = useState(minRangeDate.toDate());

  const doNovedadesFilter = () => {
    if (!Array.isArray(novedadesData)) {
      setNovedadesFiltered([]);
      return;
    }
    const filterValueNormalize = findQuery;
    const { startDate, endDate } = dateRange;
    const hasta = endDate && moment(endDate).add(23, "hour").toDate();
    const desde = startDate && moment(startDate).toDate();

    const likeFindQuery = (nov) =>
      nov.cliente.razonSocial.toLowerCase().includes(filterValueNormalize) ||
      nov.cliente.numeroDeLegajo.replace(".0000", "").includes(filterValueNormalize) ||
      nov.sucursal.titulo.toLowerCase().includes(filterValueNormalize) ||
      nov.responsable.nombreApellido.toLowerCase().includes(filterValueNormalize);
    const filteredWithStatus = novedadesWithresponsable(novedadesData).filter(
      (nov) =>
        (!clienteSelected || nov.cliente.razonSocial === clienteSelected.value) &&
        (!desde || novedadUtil(nov).endDate() >= desde) &&
        (!hasta || novedadUtil(nov).startDate() <= hasta) &&
        likeFindQuery(nov)
    );

    setKpiResults(countKpis(filteredWithStatus));

    const filtered = filteredWithStatus.filter((nov) => !filterStatus || novedadUtil(nov).statusStr(true) === filterStatus);

    setNovedadesFiltered(filtered);
    window.filtered = filtered;

    let tareasCalc = [];

    if (filtered && filtered.length === 1) {
      tareasCalc = filtered[0].tareas;
    } else if (filtered && filtered.length > 0) {
      tareasCalc = filtered.reduce((allTasks, novedad) => [...(Array.isArray(allTasks) ? allTasks : allTasks.tareas), ...novedad.tareas]);
    }
    tareasCalc = tareasCalc.filter((tarea) => (!desde || taskUtil(tarea).dueDate() >= desde) && (!hasta || taskUtil(tarea).dueDate() <= hasta));
    setTareas(tareasCalc);
    setTareasCalc(tareasCalc);

    const tareasForCalendar = tasksForCalendar(filtered, categoriesTask);
    setTareasCalendar(tareasForCalendar);
  };

  useEffect(() => {
    const { startDate } = dateRange;
    const desde = startDate && moment(startDate);

    if (desde && desde.format("M") !== minRangeDate.format("M")) {
      setDateRange({});
    }
  }, [JSON.stringify({ monthSelected })]);

  useEffect(() => {
    doNovedadesFilter();
  }, [JSON.stringify({ clienteSelected, filterStatus, findQuery, dateRange, isLoadingNovedades }), tareaUpdated]);

  const handleDatesChange = (event) => {
    setDateRange(event.rangeDates);
  };

  const handleClientChange = (event) => {
    if (event) {
      const cliente = clientesOpt.find((cli) => cli.value === event.value);
      setClienteSelected(cliente);
    } else {
      setClienteSelected(null);
    }
  };

  const handleFindByTextQueryChange = ({ target }) => {
    setFindQuery(target.value);
  };

  const handleFilterStatus = (status) => {
    setFilterStatus(status);
  };

  const handleMonthChange = (selected) => {
    const month = selected.getMonth();
    const year = selected.getFullYear();
    setMonthSelected(month);
    setYearSelected(year);
    const newDate = new Date();
    setSelectedDate(newDate.setMonth(month));
    setSelectedDate(newDate.setFullYear(year));
    const date = moment({ month: selected.getMonth(), year: selected.getFullYear() }).startOf("month").toDate();
    history.push({ search: `month=${selected.getMonth() + 1}&year=${year}` });
    setCurrentPage(1);
    setCalendarDate(date);
    refreshNovedades([{ month: selected.getMonth() + 1, year, forceRefresh: true }]);
  };

  const handleToggleModal = () => {
    setIsOpenModal(!isOpenModal);
  };

  const handleRefreshData = () => {
    refreshNovedades([{ ...novedadesFilter[0], forceRefresh: true }]);
  };

  const eventClick = (e) => {
    const eventData = tareas.find((el) => el.id === e.id);
    setEventSelected(eventData);
    handleToggleModal();
  };

  const newTaskUpdated = (updatedTask) => {
    if (updatedTask.length !== undefined) {
      for (const task of updatedTask) {
        const newTasks = [...tareasCalendar];
        const updatedTaskCalendar = {
          ...task,
          start: moment(task.dueDate).toDate(),
          end: moment(task.dueDate).add(1, "days").toDate(),
        };
        const indexUpdated = newTasks.findIndex((item) => item.id === task.id);
        newTasks[indexUpdated] = updatedTaskCalendar;
        setTareaUpdated(!tareaUpdated);
        setTareas(newTasks);
      }
    }
  };

  const getNovedad = (tarea) => {
    return novedades && novedades.rows.find((novedad) => novedad.id === tarea.novedadId);
  };

  let modalData = [];
  if (eventSelected) {
    const taskfilter = tareasCalc.filter((task) => {
      const novedad = getNovedad(task);
      const novedadRazonSocial = novedad && novedad.cliente && novedad.cliente.razonSocial;
      const novedadSelected = getNovedad(eventSelected);
      const novedadSelectedRazonSocial = novedadSelected && novedadSelected.cliente && novedadSelected.cliente.razonSocial;
      return novedadRazonSocial === novedadSelectedRazonSocial && task.title === eventSelected.title && task.centralizer;
    });
    modalData.push(taskfilter);
  }
  return (
    <>
      <Helmet>
        <title>PIN - Sistema de Recordatorios</title>
      </Helmet>
      <Breadcrumb title="Calendario centralizado" parent="Sistema de Recordatorios" onRefreshClick={handleRefreshData} />

      {eventSelected && (
        <SubclientesModal handleIsOpenModal={isOpenModal} handleToggleModal={handleToggleModal} data={modalData} novedades={novedadesFiltered}></SubclientesModal>
      )}
      <BlurSpinner isLoading={isLoadingNovedades}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-3 col-12">
                      <div className="form-group">
                        <label htmlFor="query" className="col-form-label pt-0 w-100">
                          Busqueda por texto
                          <input
                            className="form-control"
                            type="search"
                            placeholder="Buscar.."
                            onChange={handleFindByTextQueryChange}
                            name="query"
                            id="query"
                            value={findQuery}
                          />
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label htmlFor="cliente" className="col-form-label pt-0 w-100">
                          Cliente
                          <StyledSelect
                            id="cliente"
                            name="cliente"
                            isClearable
                            placeholder="Todos"
                            options={clientesOpt}
                            value={clienteSelected}
                            onChange={handleClientChange}
                          />
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label htmlFor="mes" className="col-form-label pt-0 w-100">
                          Mes y Año
                          <DatePicker
                            className="form-control digits"
                            locale={locale}
                            showMonthYearPicker
                            showFullMonthYearPicker
                            dateFormat="MMMM yyyy"
                            selected={selectedDate}
                            onChange={handleMonthChange}
                            minDate={new Date(firstDayLastYear)}
                            maxDate={moment().toDate()}
                          />
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <DateRangeComponent
                          onChange={handleDatesChange}
                          values={dateRange}
                          label="Rango de fechas"
                          minDate={minRangeDate.toDate()}
                          maxDate={maxRangeDate.toDate()}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xl-3 col-sm-6">
                      <KpiCard
                        statusDef={{
                          color: "00B398",
                          id: null,
                          status: "active",
                          text: "Total",
                        }}
                        icon={faCalculator}
                        value={{
                          count: kpiTotal,
                        }}
                        total={kpiTotal}
                        onClick={handleFilterStatus}
                        selected={!filterStatus}
                      />
                    </div>
                    <div className="col-xl-3 col-sm-6">
                      <KpiCard
                        statusDef={{
                          color: "f2a900",
                          id: statusNovedad.PENDIENTE,
                          status: "active",
                          text: "Pendiente",
                        }}
                        icon={faClock}
                        value={{
                          count: kpiPendiente,
                        }}
                        total={kpiTotal}
                        onClick={handleFilterStatus}
                        selected={filterStatus === statusNovedad.PENDIENTE}
                      />
                    </div>
                    <div className="col-xl-3 col-sm-6">
                      <KpiCard
                        statusDef={{
                          color: "17a2b8",
                          id: statusNovedad.GESTION,
                          status: "active",
                          text: "En gestión",
                        }}
                        icon={faHeadSideVirus}
                        value={{
                          count: kpiGestion,
                        }}
                        total={kpiTotal}
                        onClick={handleFilterStatus}
                        selected={filterStatus === statusNovedad.GESTION}
                      />
                    </div>
                    <div className="col-xl-3 col-sm-6">
                      <KpiCard
                        statusDef={{
                          color: "43b02a",
                          id: statusNovedad.RESUELTA,
                          status: "active",
                          text: "Resuelto",
                        }}
                        icon={faCheck}
                        value={{
                          count: kpiResuelto,
                        }}
                        total={kpiTotal}
                        onClick={handleFilterStatus}
                        selected={filterStatus === statusNovedad.RESUELTA}
                      />
                    </div>
                  </div>
                  <Tabs activeKey="tasks">
                    <Tab eventKey="tasks" title="Tareas">
                      <div className="table-responsive support-table">
                        {isLoadingNovedades || errNovedades ? (
                          <></>
                        ) : (
                          <TaskListTableCentralizer
                            tasks={tareasCalc}
                            novedades={novedadesFiltered}
                            handleClickTask={eventClick}
                            newTaskUpdated={newTaskUpdated}
                            withPaging
                            centralizer={true}
                          />
                        )}
                      </div>
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BlurSpinner>
    </>
  );
};

export default withRouter(CalendarsCentralizer);
